import { render } from "./QuizItem.vue?vue&type=template&id=5fa1d639&scoped=true"
import script from "./QuizItem.vue?vue&type=script&lang=js"
export * from "./QuizItem.vue?vue&type=script&lang=js"

import "./QuizItem.vue?vue&type=style&index=0&id=5fa1d639&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa1d639"]])

export default __exports__